import { useState } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Statistics } from "@/components/landing/Statistics";
import { Leaderboard } from "@/components/landing/Leaderboard";
import { NewestPilots } from "@/components/landing/NewestPilots";
import { Awards } from "@/components/landing/Awards";
import { Footer } from "@/components/landing/Footer";
import { useThemeColors } from "@/hooks/use-theme-colors";

const THEME_STORAGE_KEY = "aiv_theme_position";

// Lazy initializer runs synchronously during the first render (before any
// paint), so the wrapper's CSS custom properties are correct from the very
// first DOM commit — no flash of default-Dusk content while this loads.
function getInitialThemePosition() {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    const parsed = raw === null ? NaN : parseFloat(raw);
    if (Number.isFinite(parsed) && parsed >= 0 && parsed <= 100) {
      return parsed;
    }
  } catch {
    // localStorage unavailable (private browsing) — fall through to default.
  }
  return 0;
}

export default function Landing() {
  const [themePosition, setThemePosition] = useState(getInitialThemePosition);
  const { style, heroFilter } = useThemeColors(themePosition);

  const handlePositionChange = (next) => {
    setThemePosition(next);
  };

  const handlePositionCommit = (next) => {
    try {
      localStorage.setItem(THEME_STORAGE_KEY, String(next));
    } catch {
      // localStorage unavailable — position still updates in-memory for this session.
    }
  };

  return (
    <div
      className="aiv-themed relative min-h-screen transition-[background-color,color,border-color] duration-[600ms] ease-out"
      style={style}
      data-testid="landing-page"
    >
      <Navbar
        themePosition={themePosition}
        onPositionChange={handlePositionChange}
        onPositionCommit={handlePositionCommit}
      />
      <main>
        <Hero heroFilter={heroFilter} />
        <About />
        <Statistics />
        <Leaderboard />
        <NewestPilots />
        <Awards />
      </main>
      <Footer />
    </div>
  );
}
